import React from 'react';

import { ActionPermissions } from '../../../@types';
import { isUserHasPermission } from '../../../configs/permissions';
import { useGetUserSystemPermissions } from '../../../queries/user-query';
import { CreateService } from '../CreateService';

// Routing in MainRoutes only mounts AddEditService when the URL param is
// `create`; existing services route through ServiceDetailRouter (location- vs
// serial-based detail layouts). The legacy UpdateService page used to handle
// the edit branch here but is no longer reachable.
export const AddEditService: React.FC = () => {
  const getUserPermissionsQuery = useGetUserSystemPermissions();

  if (isUserHasPermission(ActionPermissions.Service_Create, getUserPermissionsQuery.data)) {
    return <CreateService />;
  }
  return null;
};
